import { render, staticRenderFns } from "./DashboardWidget.vue?vue&type=template&id=cf0bc610&scoped=true"
import script from "./DashboardWidget.vue?vue&type=script&lang=js"
export * from "./DashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidget.vue?vue&type=style&index=0&id=cf0bc610&prod&lang=scss&scoped=true"
import style1 from "./DashboardWidget.vue?vue&type=style&index=1&id=cf0bc610&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0bc610",
  null
  
)

export default component.exports